import gql from 'graphql-tag';

const pendingReturnInvoicesQuery = gql`
  query pendingReturnInvoices(
    $dealerNumber: String
    $vin: String
    $vra: String
    $size: Int
    $offset: Int
  ) {
    pendingReturnInvoices(
      dealerNumber: $dealerNumber
      vin: $vin
      vra: $vra
      size: $size
      offset: $offset
    ) {
      id
      odometerOnReturn
      returnInitiatedAt
      expirationDate
      additionalInformation
      transaction {
        id
        purchasePrice
      }
      auctionLocation {
        name
        initials
      }
      returningUser {
        id
        username
        email
      }
      pendingReasons {
        id
        code
        notice
      }
      guaranteePurchase {
        id
        partner
        kind
        guaranteedAt
        guaranteeOffer {
          id
          dealerName
          guaranteePrice
          milesSelected
          daysSelected
          transportReimbursement
          emails
          vehicleInformation {
            id
            vin
            year
            make
            model
            odometerReading
          }
          auctionInformation {
            id
            dealerNumber
            vehiclePurchasePrice
            buyFee
            auctionAccessNumber
          }
        }
      }
    }
  }
`;

export default pendingReturnInvoicesQuery;
